export default __webpack_public_path__ + "static/media/ghpages.273bbcfc.png";